module.exports = __webpack_public_path__ + "static/media/user1.e712dc8b.jpg";